import React from 'react'
import InputFiles from 'react-input-files'
import { adicionarComprovante } from './Comprovantes'
import { icon } from '../Icons'

export default function UpLoad(props) {

    const removerAnexos = (id,nomeArquivo) => {
        props.removerAnexos(id,nomeArquivo)
        props.setMensagem({tipo:'LIMPAR'})
    }

    const renderAnexos = () => {
        if (!props.anexosDto) {
            return null
        }
        if (props.anexosDto.length === 0) {
            return null
        }
        const anexos = props.anexosDto
        return( 
            <div>
                    {
                        anexos.map((anexo, index) => {  
                            return (
                                <li key={"keyHtmlComprovanteAnexoBotaoTrash_" + index }> 
                                    {anexo.nomeArquivo}&nbsp;&nbsp;
                                    {anexo.tamanho}&nbsp;bytes&nbsp;&nbsp;
                                    <button 
                                        id={ "idHtmlComprovanteAnexoBotaoTrash_" + index }
                                        className="btn btn-default"
                                        onClick={ 
                                            () => removerAnexos(
                                                "idHtmlComprovanteAnexoBotaoTrash_" + index,
                                                anexo.nomeArquivo
                                            ) 
                                        }
                                        type="button"
                                    >
                                        <icon.FaRegTrashAlt className="text-danger" aria-hidden="true" />
                                    </button>
                                </li>
                            )
                        })
                    }
                <br />
            </div>
        )
    }
    
    const abreFormularioPostagens = () => {
        props.atuLinhaDoTempo('postagens')
    }

    const abreFormularioBotaoSubmit = () => {
        props.atuLinhaDoTempo('submit')
    }

    const secaoUpLoad = () => {
        return (
            <>
                { renderAnexos() }
                <div className="ml-1">
                    <InputFiles 
                        accept="*/*"
                        onChange={ files => adicionarComprovante(props,files[0]) }
                        name="adicionaComprovantes"
                    >
                        <button type="button" className="row btn-success btn-sm">
                            <icon.FaRegFolderOpen size={32} aria-hidden="true" /> 
                            &nbsp;
                            <div className="text-nowrap mt-1">
                                UpLoad de documentos...
                            </div>
                        </button>
                    </InputFiles>
                </div>
            </>
        )
    }

    if (!props.linhaDoTempo) {
        return null
    }
    if (props.linhaDoTempo.emPauta !== "enviarArquivos") {
        return null
    }

    return (
        <>
            <fieldset className="border p-4 mt-4">
                <legend className="row w-auto">
                    <h4 className="ml-1"><small>Enviar arquivos:</small></h4> 
                </legend>
                { secaoUpLoad() }
            </fieldset>
            <div className="mt-4">
                <div className="d-flex justify-content-between">
                    <button 
                        type="button" 
                        className="btn btn-outline-primary" 
                        onClick={ abreFormularioPostagens }
                    >
                        Anterior
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-outline-primary " 
                        onClick={ abreFormularioBotaoSubmit }
                    >
                        Próximo
                    </button>
                </div>
            </div>
        </>
    )
}